/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deregisterWebAuthnCredentialInternal} from '../api'

export const useMutationDeregisterWebAuthnCredentialInternal = createReactQueryMutationHook('deregisterWebAuthnCredentialInternal', deregisterWebAuthnCredentialInternal)
